import {LEAGUE_CONFIGS} from '../../configs/leagues';

/**
 * Соседняя лига: offset +1 — на ступень выше, -1 — ниже. За краями шкалы
 * остается крайняя лига: ниже бронзы и выше божественной ничего нет.
 */
export const shiftLeague = (leagueId, offset) => {
  const index = LEAGUE_CONFIGS.findIndex((league) => league.id === leagueId);
  if (index === -1) {
    return leagueId;
  }
  const shifted = Math.min(LEAGUE_CONFIGS.length - 1, Math.max(0, index + offset));
  return LEAGUE_CONFIGS[shifted].id;
};

/** Нижняя граница следующей лиги; undefined у самой верхней */
export const getNextLeagueMinRating = (leagueId) => {
  const index = LEAGUE_CONFIGS.findIndex((league) => league.id === leagueId);
  if (index === -1 || index === LEAGUE_CONFIGS.length - 1) {
    return undefined;
  }
  return LEAGUE_CONFIGS[index + 1].minRating;
};
